// let environment = "local";
// // let apiUrl = "http://localhost:8000/api/v1/";
// // let apiUrl = "http://192.168.4.4:8000/api/v1/";
// let apiUrl = "http://192.168.4.18:8000/api/v1/";

const environment = process.env.REACT_APP_ENV;
let apiUrl = process.env.REACT_APP_API_URL_LOCAL;

if (environment === "production") {
  apiUrl = process.env.REACT_APP_API_URL;
}

export class ConfigDB {
  static data = {
    app_name: "TP-SOFT",
    api_url: apiUrl,
    login_data: "@secure.@data",
    ROLE_ADMIN: 1,
    dataTableLength: [10, 25, 75, 100],
    typeList: [
      { value: 1, label: "Percentage (Ex: VAT)" },
      { value: 2, label: "Fixed Value" },
      { value: 3, label: "Item Based" },
    ],
    saftTypeList: [
      { value: 1, label: "VAT" },
      { value: 2, label: "Stamp Duty" },
      { value: 3, label: "Other" },
    ],
    vatTypeList: [
      { value: "RED", label: "Reduced VAT" },
      { value: "INT", label: "Intermediate VAT" },
      { value: "NOR", label: "Standard VAT" },
      { value: "ISE", label: "Exempt VAT" },
      { value: "OUT", label: "Other VAT" },
    ],
    inventoryStatusFilterList: [
      { value: 0, label: "All State" },
      { value: 1, label: "In Stock" },
    ],
    vehicleStatusFilterList: [
      { value: 0, label: "All State" },
      { value: 1, label: "In Stock" },
    ],
     visibilityList: [
      { value: 1, label: "Visible" },
      { value: 2, label: "In Visible" },
    ],
      copyQuantityList: [
      { value: 1, label: "Original" },
      { value: 2, label: "Duplicate" },
      { value: 2, label: "Triplicate" },
      { value: 2, label: "Quadruplicate" },

    ],
      costPriceBasedOnList: [
      { value: 1, label: "Cost Price Based At Percentages" },
      { value: 2, label: "Cost Price Based At Relation Of Weights" },
    ],
    partQuantityList: [
      { value: 0, label: "All" },
      { value:1, label: "Active Quantity" },
      { value:2, label: "Deleted Quantity" },

    ],

   partCheckList: [
      { value: 0, label: "All" },
      { value:1, label: "Verified" },
      { value:2, label: "Non Existent" },
      { value:3, label: "Part to be Verified" },
    ],

    partCheckConvertedList: [
      { value: 0, label: "All" },
      { value:1, label: "Only Converted to Inventory" },
     
    ],

   ExemptionReasonList : [
  { value: "M01", label: "M01" },
  { value: "M02", label: "M02" },
  { value: "M04", label: "M04" },
  { value: "M05", label: "M05" },
  { value: "M06", label: "M06" },
  { value: "M07", label: "M07" },
  { value: "M09", label: "M09" },
  { value: "M10", label: "M10" },
  { value: "M11", label: "M11" },
  { value: "M12", label: "M12" },
  { value: "M13", label: "M13" },
  { value: "M14", label: "M14" },
  { value: "M15", label: "M15" },
  { value: "M16", label: "M16" },
  { value: "M19", label: "M19" },
  { value: "M20", label: "M20" },
  { value: "M21", label: "M21" },
  { value: "M25", label: "M25" },
  { value: "M30", label: "M30" },
  { value: "M31", label: "M31" },
  { value: "M32", label: "M32" },
  { value: "M33", label: "M33" },
  { value: "M34", label: "M34" },
  { value: "M40", label: "M40" },
  { value: "M41", label: "M41" },
  { value: "M42", label: "M42" },
  { value: "M43", label: "M43" },
  { value: "M99", label: "M99" },
]
  };
}

export default ConfigDB;
